<template>
    <div class="gallery">
        <div class="gallery-item-featured">
            <img :src="featuredImage || images[0]" :alt="trans.gallery.item || 'Gallery Item'" />
        </div>

        <div class="gallery-items">
            <div
                v-for="image in images"
                :key="image"
                class="gallery-item"
                @click="handleClick(image)"
            >
                <img :src="image" :alt="trans.gallery.item || 'Gallery Item'" />
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.gallery {
    img {
        width: 100%;
    }

    &-item-featured {
        width: 100%;
        border-radius: 8px;
        overflow: hidden;
        margin-bottom: 8px;
        line-height: 1;
    }

    &-items {
        display: flex;
        justify-content: center;
        gap: 8px;
    }

    &-item {
        width: 48px;
        height: 48px;
        border-radius: 8px;
        overflow: hidden;
        cursor: pointer;
        line-height: 1;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
}
</style>

<script>
export default {
    props: {
        featuredImage: {
            type: String,
            required: true
        },
        images: {
            type: Array,
            required: true
        },
        trans: {
            type: Object,
            required: false
        }
    },
    methods: {
        handleClick(image) {
            this.featuredImage = image;
        }
    }
};
</script>
